export default "__VITE_ASSET__D7JAu0w3__"